import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";
import { TechCoverTicketCreate } from "src/app/models/TechCoverTicketCreate";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { TechCoverTicket } from "../models/TechCoverTicket";

@Injectable({
  providedIn: "root",
})
export class TechCoverTicketService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/techCoverTickets`;

  constructor(private http: HttpClient) {}

  public getOpenSupportTicketsCountAsync(companyId: string): Observable<number> {
    return this.http.get<number>(`${this.baseUrl_V2}/${companyId}/openTicketCount`);
  }

  public async getSupportTicketsAsync(companyId: string): Promise<TechCoverTicket[]> {
    const tickets = await firstValueFrom(
      this.http.get<TechCoverTicket[]>(`${this.baseUrl_V2}/${companyId}`),
    );
    return tickets.map((ticket) => new TechCoverTicket().deserialize(ticket));
  }

  public createSupportTicketAsync(ticket: TechCoverTicketCreate): Promise<string> {
    return firstValueFrom(this.http.post<string>(`${this.baseUrl_V2}`, ticket));
  }
}
